module.exports = __webpack_public_path__ + "img/module-title-01_red.2a99754a.jpg";